<template>
  <div
    v-if="inVMXCheck && inAppCheck && carousel.length > 0"
    class="highlighted-sessions"
  >
    <div class="highlighted-sessions__titleSection">
      <h2
        class="highlighted-sessions__title"
        v-if="title"
      >
        {{ title }}
      </h2>
      <p
        v-if="subtitle"
        v-html="subtitle"
      />
    </div>
    <div class="slider-container" v-if="carousel.length > 0">
      <div
        class="slider-button __before" @click="goBack()"
        v-if="showCarousel && showCarouselButtons"
      >
        <font-awesome-icon :icon="['fas', 'chevron-left']" />
      </div>
      <div 
        class="slider-button __next" @click="goNext()"
         v-if="showCarousel && showCarouselButtons"
      > 
        <font-awesome-icon :icon="['fas', 'chevron-right']" />
      </div>
      <template v-if="highlightedItems === 'Sessions'">
        <div
          class="highlighted-sessions__list"
          :class="showCarouselButtons && carouselPadding ? 'highlighted-sessions__list-buttons' : ''"
          @mouseover="mouseover"
          @mouseleave="mouseleave"
        >
          <div
            class="highlighted-sessions__list__item"
            v-for="(session, idx) in carousel"
            :key="idx"
          >
            <transition name="slide">
              <session-card-v2
                :session="session"
                :key="componentKey"
                :show-session-color="showSessionColor"
                :show-presentation-color="showPresentationColor"
                :clickable="!!eventShortProps"
              />
            </transition>
          </div>
        </div>
      </template>
      <template v-if="highlightedItems === 'Presentations'">
        <div
          class="highlighted-sessions__list"
          :class="showCarouselButtons && carouselPadding ? 'highlighted-sessions__list-buttons' : ''"
          @mouseover="mouseover"
          @mouseleave="mouseleave"
        >
          <div
            class="highlighted-sessions__list__item"
            v-for="(presentation, idx) in carousel"
            :key="idx"
          >
            <transition name="slide">
              <session-card-v2
                :presentation="presentation"
                :show-abstract-number="showAbstractNumber"
                :key="componentKey"
                :show-session-color="showSessionColor"
                :show-presentation-color="showPresentationColor"
              />
            </transition>
          </div>
        </div>
      </template>
      <template v-if="highlightedItems === 'Authors'">
        <div
          class="highlighted-sessions__list"
          :class="showCarouselButtons && carouselPadding ? 'highlighted-sessions__list-buttons' : ''"
          @mouseover="mouseover"
          @mouseleave="mouseleave"
        >
          <div
            class="highlighted-sessions__list__item"
            v-for="(author, idx) in carousel"
            :key="idx"
          >
            <transition name="slide">
              <session-card-v2
                :author="author"
                :key="componentKey"
                :show-session-color="showSessionColor"
                :show-presentation-color="showPresentationColor"
              />
            </transition>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SessionCardV2 from './sessionCardV2.vue'

export default {
  name: 'HighlightedSessionsV2',
  components: { SessionCardV2 },
  data() {
    return {
      sessions: [],
      carousel: [],
      carouselStorage: [],
      tempArray: [],
      tempCarouselArray: [],
      presentations: [],
      authors: [],
      componentKey: 0,
      carouselLength: 3,
      carouselInterval: null,
    }
  },
  props: {
    highlightedItems: {
      type: String,
      default: 'Sessions',
    },
    programGrade: {
      type: String,
      default: 'Scientific',
    },
    eventShortProps: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    carouselTime: {
      type: Number,
      default: 10000,
    },
    showCarousel: {
      type: Boolean,
      default: false,
    },
    showCarouselButtons: {
      type: Boolean,
      default: false,
    },
    carouselPadding: {
      type: Boolean,
      default: false,
    },
    showAbstractNumber: {
      type: Boolean,
      default: false,
    },
    showSessionColor: {
      type: Boolean,
      default: true,
    },
    showPresentationColor: {
      type: Boolean,
      default: false,
    },
    sessionTypes: {
      type: Array,
      default: () => {
        return []
      }
    },
    presentationTypes: {
      type: Array,
      default: () => {
        return []
      }
    },
    onlyInApp: {
      type: Boolean,
      default: false,
    },
    onlyInVMX: {
      type: Boolean,
      default: false,
    },
    inApp: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      list: 'highlightedSessions/list',
      presentationList: 'highlightedSessions/presentationList',
      authorList: 'highlightedSessions/authorList',
      isAppContainer: 'instancesState/getIsAppContainer',
    }),
    inAppCheck() {
      if (this.isAppContainer) {
        return this.inApp
      }
      return !this.onlyInApp
    },
    inVMXCheck() {
      if (this.isAppContainer && this.onlyInVMX) {
        return false
      }
      return true
    },
    rotate() {
      let carouselLength = 0
      switch (this.highlightedItems) {
        case 'Presentations':
          carouselLength = this.presentations ? this.presentations.length > 3 : 0
          break
        case 'Authors':
          carouselLength = this.authors ? this.authors.length > 3 : 0
          break
        default:
          carouselLength = this.sessions ? this.sessions.length > 3 : 0
          break
      }
      return this.showCarousel && carouselLength
    },
  },
  methods: {
    ...mapActions({
      load: 'highlightedSessions/load',
      presentationLoad: 'highlightedSessions/loadPresentations',
      authorLoad: 'highlightedSessions/loadAuthors',
    }),
    goNext() {
      const firstItem = this.carousel[0]
      const firstItemInStorage = this.carouselStorage[0]

      this.carousel.shift()
      this.carouselStorage.push(firstItem)
      this.carousel.push(firstItemInStorage)
      this.carouselStorage.shift()

    },
    goBack() {
      const lastItem = this.carousel[this.carousel.length - 1]
      const lastItemInStorage = this.carouselStorage[this.carouselStorage.length - 1]

      this.carousel.unshift(lastItemInStorage)
      this.carousel.pop()
      this.carouselStorage.unshift(lastItem)
      this.carouselStorage.pop()
    },
    forceRerender() {
      this.componentKey += 1
    },
    resizeHandler() {
      if (this.rotate) {
        if (document.body.clientWidth > 992) {
          clearInterval(this.carouselInterval)
          this.createCarousel()
          this.createInterval()
        }
        if (
          document.body.clientWidth < 992
          && document.body.clientWidth > 786
        ) {
          clearInterval(this.carouselInterval)
          this.createCarousel()
          this.createInterval()
        }
        if (document.body.clientWidth < 786) {
          clearInterval(this.carouselInterval)
          this.createCarousel()
          this.createInterval()
        }
      }
    },
    resetArrays() {
      this.tempArray = []
      this.tempCarouselArray = []
      this.carousel = []
      this.carouselStorage = []
    },
    createCarousel() {
      this.resetArrays()
      switch (this.highlightedItems) {
        case 'Presentations':
          this.tempArray = [...this.presentations]
          break
        case 'Authors':
          this.tempArray = [...this.authors]
          break
        default:
          this.tempArray = [...this.sessions]
          break
      }
      if (document.body.clientWidth > 992 && this.tempArray.length > 2) {
        this.carouselLength = 3
      }
      if (document.body.clientWidth < 992 && document.body.clientWidth > 786) {
        this.carouselLength = 2
      }
      if (document.body.clientWidth < 786) {
        this.carouselLength = 1
      }

      for (let i = 0; i < this.carouselLength; i += 1) {
        if (!this.carousel.includes(this.tempArray[i])) { this.carousel.push(this.tempArray[i]) }
      }
      this.tempCarouselArray = [...this.carousel]
      this.carouselStorage = this.tempArray.filter(
        (item) => !this.tempCarouselArray.includes(item),
      )
    },
    createInterval() {
      this.carouselInterval = setInterval(() => {
        const shiftedItem = this.carousel[0]
        this.carousel.shift()
        this.carouselStorage.push(shiftedItem)
        this.carousel.push(this.carouselStorage[0])
        this.carouselStorage.shift()

        this.forceRerender()
      }, this.carouselTime)
    },
    mouseover() {
      if (this.carouselInterval) clearInterval(this.carouselInterval)
    },
    mouseleave() {
      if (this.rotate) {
        this.createInterval()
      }
    },
  },
  async beforeDestroy() {
    if (this.rotate) {
      window.removeEventListener('resize', this.resizeHandler)
    }
  },
  async created() {
    switch (this.highlightedItems) {
      case 'Presentations':
        await this.presentationLoad({ eventShort: this.eventShortProps })
        this.presentations = this.presentationList
        if(this.presentationTypes.length > 0) this.presentations = this.presentations.filter((presentation) => this.presentationTypes.includes(presentation.PresentationTypeName))
        if (this.presentations) {
          this.presentations.sort((a, b) => {
            if (a.Sort > b.Sort) {
              return 1
            }
            if (b.Sort > a.Sort) {
              return -1
            }
            return 0
          })
          this.carousel = this.presentations
        }
        break
      case 'Authors':
        await this.authorLoad({ eventShort: this.eventShortProps })
        this.authors = this.authorList

        if (this.authors) {
          this.authors.sort((a, b) => {
            if (a.Surname > b.Surname) {
              return 1
            }
            if (b.Surname > a.Surname) {
              return -1
            }
            return 0
          })
          this.carousel = this.authors
        }
        break
      default:
        await this.load({ programGrade: this.programGrade, eventShort: this.eventShortProps })
        this.sessions = this.list(this.programGrade)
        if(this.sessionTypes.length > 0) this.sessions = this.sessions.filter((session) => this.sessionTypes.includes(session.SessionType))
        if (this.sessions) {
          this.sessions.sort((a, b) => {
            if (a.StartDateTime > b.StartDateTime) {
              return 1
            }
            if (b.StartDateTime > a.StartDateTime) {
              return -1
            }
            return 0
          })
          this.carousel = this.sessions
        }
        break
    }

    if (!this.sessions || !this.presentations || !this.authors) {
      this.$emit('disableTitle')
    }

    if (this.rotate) {
      this.carousel = []
      window.addEventListener('resize', this.resizeHandler)
      this.createCarousel()
      this.createInterval()
    }
  },
}
</script>

<style lang="scss">
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
  max-height: 0;
}
.slide-leave-to {
  transform: translate(-100%, 0);
  max-height: 0;
  opacity: 0;
}

.highlighted-sessions__titleSection {
  margin-top: var(--link-box-grid-gap);
  margin-bottom: calc(1.5 * var(--link-box-grid-gap));
}
.highlighted-sessions__title {
  margin-bottom: 1rem;
  font-size: 26px;
  font-weight: bold;
}

.highlighted-sessions__list {
  // margin-bottom: -#{$c-grid-gutter};
  // margin-right: -#{$c-grid-gutter};
  gap: var(--link-box-grid-gap);
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  // overflow: hidden;
  min-width: 100%;
  overflow: hidden;
}
.highlighted-sessions__list-buttons {
  padding: 0 3.5rem;
}

.highlighted-sessions__list__item {
  // margin: 0 10px 10px 0;
  flex: 0 0 100%;
  width: 100%;

  a:hover {
    text-decoration: none;
    filter: none !important;
  }
}
.highlighted-cards {
  overflow: hidden;
}
.slider-container {
  position: relative;
}

.slider-button{
    background: var(--secondary);
    border-radius: 0;
    transform: none;
    position: absolute;
    z-index: 1;
    width: 50px;
    height: 50px;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 1.5rem;
    opacity: 0.9;
    cursor: pointer;
    box-shadow: none;
    border: none;
  &.__before {
    left: 0;
  }

  &.__next {
    right: 0;
  }

}

.slider-button:hover{
  opacity: 0.8;
}

/* tablet */
@media (min-width: 768px) {
  .highlighted-sessions__list__item {
    flex-basis: calc(50% - calc(var(--link-box-grid-gap) * 0.5));
    width: calc(50% - calc(var(--link-box-grid-gap) * 0.5));
  }

  .component-grid__item--is-one-third {
    .highlighted-sessions__list__item {
      flex-basis: calc(100% - var(--c-grid-gutter));
    }
  }
}

/* Desktop */
@media (min-width: 992px) {
  .highlighted-sessions__list__item {
    flex-basis: calc(33.33333% - calc(var(--link-box-grid-gap) * calc(2 / 3)));
    width: calc(33.33333% - calc(var(--link-box-grid-gap) * calc(2 / 3)));
  }

  .component-grid__item--is-two-thirds {
    .highlighted-sessions__list__item {
      flex-basis: calc(50% - var(--c-grid-gutter));
    }
  }

  .component-grid__item--is-one-third {
    .highlighted-sessions__list__item {
      flex-basis: calc(100% - var(--c-grid-gutter));
    }
  }
}
</style>
